import { LayoutComponent } from '../../components/layout/LayoutComponent'
import React, { ReactNode, useContext, useEffect, useState } from 'react'
import { getCommerceInfo } from '../../services/commerce'
import { track } from '../../ClevertapWrapper'
import { useNavigate } from 'react-router-dom'
import { clevertapEvents } from '../../labels'
import routes from '../../router/routes'
import { useUpselling } from '../../hooks/useUpselling'
import { format } from 'date-fns'
import {
    getLocal,
    getLocalAddress,
    isAdmin,
    isLocalView,
} from '../../Utils/Profile'
import ModalComponent from '../../components/modal/ModalComponent'
import Text from '../../components/text/Text'
import './Layout.module.css'
import OutlinedInput from '../../components/outlinedInput/OutlinedInput'
import { useLoadingContext } from '../../context/spinnerContext'
import { getStores } from '../../services/stores'
import { getCategoriesByCommerce } from '../../services/products'
import AmipassLogo from '../../assets/icons/amipass-white.svg'
import drawerAnalitycsIcon from '../../assets/icons/drawer-icon-analitycs.png'
import drawerProductListIcon from '../../assets/icons/drawer-icon-product-list.png'
import drawerBellIcon from '../../assets/icons/drawer-icon-bell.png'
import key from '../../assets/icons/icons-key.png'
import reporte from '../../assets/icons/reporte-ventas-drawer.png'

import subscriptionIcon from '../../assets/icons/my-plan-icon.png'

import { FeatureContext } from '../../context/useFeatureFlagContext'
import SvgIcon from '../../components/svgIcon/SvgIcon'
import { getStoreProfileData } from '../../services/storeProfile'
interface ILocalData {
    address: string
    shopId: string
    region: string
    localId: string
}

interface ILayoutProps {
    children: ReactNode
}

export default function Layout({ children }: ILayoutProps) {
    const navigate = useNavigate()
    const loadingContext = useLoadingContext()

    const { features } = useContext(FeatureContext)

    const [showStoreModal, setShowStoreModal] = useState<boolean>(false)
    const [searchTerm, setSearchTerm] = useState<string>('')

    const upselling = useUpselling()
    const isUserAdmin = isAdmin()

    const isLocalViewApplied = isLocalView()

    const currentUser = localStorage.getItem('currentUser')
    const user = currentUser && JSON.parse(currentUser)
    const commerceId = user?.sEstablecimiento + getLocal()
    const [commerce, setCommerce] = useState<any>()
    const [establishment, setEstablishment] = useState<any>()
    const [storeList, setStoreList] = useState<ILocalData[]>([])
    const [filteredStores, setFilteredStores] = useState<ILocalData[]>([])

    const [selectedLocal, setSelectedLocal] = useState<string>()
    const [selectedLocalId, setSelectedLocalId] = useState<string>()

    const [isSingleStore, setIsSingleStore] = useState(false)
    const getAllStores = async () => {
        loadingContext?.onOpen()
        try {
            const data = await getStores()

            if (data.length > 0) {
                setStoreList(data)
                setFilteredStores(data)

                if (data.length === 1) {
                    setIsSingleStore(true)
                } else {
                    setIsSingleStore(false)
                }
            } else {
                setStoreList([])
                setFilteredStores([])
                setIsSingleStore(false)
            }
        } catch (err) {
            console.error('Error al cargar los comercios.', err)
        } finally {
            loadingContext?.onClose()
        }
    }

    useEffect(() => {
        if (isAdmin()) {
            getAllStores()
        }
    }, [commerceId])

    const drawerEventParms = {
        pageName: 'Home',
        pageURL: routes.home,
        date: format(new Date(), 'yyyy/MM/dd'),
        hour: format(new Date(), 'kk:mm:ss'),
        codComercio: user?.sEstablecimiento,
        nombreComercio: user?.sNombre,
        codLocal: user?.cLocal[0].sLocal,
        rut: user?.sRut,
        mailLogin: user?.sEmailContacto,
    }

    useEffect(() => {
        getStoreProfileData().then((resp) => {
            setEstablishment({
                id: resp?.id,
                rut: resp?.establishmentRut,
                name: resp?.establishmentName,
                address: resp?.establishmentAddress,
            })
        })

        if (commerceId) {
            getCommerceInfo(commerceId).then((resp) => {
                setCommerce(resp)
            })
        }
    }, [commerceId])

    const handlerNavigate = (route: string, _track?: string) => {
        if (_track) {
            track(_track)
        }

        navigate(route)
    }

    const handlerLogout = () => {
        track(clevertapEvents.drawerLogout)
        localStorage.clear()
        localStorage.setItem('acceptTerms', 'true')
        setTimeout(() => {
            window.location.href = '/'
        }, 300)
    }
    const handleSearchChange = (event: React.ChangeEvent<HTMLInputElement>) => {
        const value = event.target.value.toLocaleLowerCase()
        setSearchTerm(value)
    }
    useEffect(() => {
        if (searchTerm && searchTerm.length > 1) {
            setSelectedLocal(undefined)

            const normalizeText = (text: string) =>
                text.toLowerCase().replace(/\s+/g, ' ').replace(/\.\s*/g, '. ')

            const lowerCaseSearchTerm = normalizeText(searchTerm)

            const filtered = storeList.filter(
                (store) =>
                    normalizeText(store.address).includes(
                        lowerCaseSearchTerm
                    ) ||
                    normalizeText(store.shopId).includes(lowerCaseSearchTerm)
            )

            setFilteredStores(filtered)
        } else {
            setFilteredStores(storeList)
        }
    }, [searchTerm, storeList])

    const onReset = () => {
        setSearchTerm('')
    }

    const closeModal = () => {
        onReset()
        setShowStoreModal(false)
    }

    const TableItem = ({ address, shopId, region, localId }: ILocalData) => {
        const handleOnClick = () => {
            setSelectedLocal(shopId.toString())
            setSelectedLocalId(localId.toString())
        }

        const isSelected = shopId === selectedLocal

        return (
            <div
                key={address}
                onClick={handleOnClick}
                className="pointer"
                style={
                    isSelected
                        ? { backgroundColor: '#2699D6', borderRadius: 4 }
                        : {}
                }
            >
                <div
                    style={{
                        display: 'flex',
                        flexDirection: 'row',
                        alignItems: 'center',
                        gap: 8,
                        paddingTop: 5,
                        paddingBottom: 5,
                        width: '90%',
                        marginLeft: '5%',
                    }}
                >
                    <Text
                        label={shopId}
                        fontSize={14}
                        fontWeight={600}
                        color={isSelected ? '#F2F2F2' : '#656565'}
                        whiteSpace="nowrap"
                    />
                    <Text
                        label={`${address}, ${region}`}
                        fontSize={12}
                        fontWeight={400}
                        color={isSelected ? '#F2F2F2' : '#656565'}
                        whiteSpace="nowrap"
                        variant="store-local-text"
                    />
                </div>
            </div>
        )
    }
    const renderChangeStore = () => {
        return (
            <ModalComponent
                show={showStoreModal}
                handleClose={() => setShowStoreModal}
                icon={false}
                modalStyle={'store-modal-container'}
            >
                <div
                    style={{
                        width: '90%',
                        marginLeft: '5%',
                    }}
                >
                    <Text
                        label="Selecciona tu local:"
                        fontSize={14}
                        fontWeight={600}
                        color="#184287"
                    />
                    <OutlinedInput
                        placeholder="Busca tu local aquí"
                        charCounter
                        trailingIcon="search"
                        value={searchTerm}
                        onChange={handleSearchChange}
                        inputStyle={{
                            textAlign: 'center',
                        }}
                    />
                </div>
                <div style={{ height: 150, overflow: 'auto' }}>
                    {filteredStores.length > 0 ? (
                        filteredStores.map((store) => (
                            <TableItem
                                {...store}
                                key={`${store.address}${store.shopId}`}
                            />
                        ))
                    ) : (
                        <Text
                            label="No se encontraron locales."
                            fontSize={14}
                            color="#565656"
                        />
                    )}
                </div>

                <div
                    style={{
                        height: '36px',
                        width: '90%',
                        backgroundColor: '#74BE00',
                        borderRadius: 5,
                        display: 'flex',
                        alignSelf: 'center',
                        justifyContent: 'center',
                        alignItems: 'center',
                        marginLeft: '5%',
                        marginTop: 5,
                    }}
                    className="pointer"
                    onClick={async () => {
                        if (selectedLocal && selectedLocalId) {
                            setShowStoreModal(false)
                            localStorage.setItem('selectedLocal', selectedLocal)
                            localStorage.setItem(
                                'selectedLocalId',
                                selectedLocalId
                            )
                            await getCategoriesByCommerce()
                            onReset()
                            navigate(`/${routes.localMain}`)
                        }
                    }}
                >
                    <Text
                        label="Ir al local"
                        fontSize={14}
                        fontWeight={600}
                        color="white"
                    />
                </div>
                {isLocalView() && (
                    <div
                        onClick={() => {
                            onReset()
                            setShowStoreModal(false)
                            setSelectedLocal(undefined)
                            localStorage.removeItem('selectedLocal')
                            localStorage.removeItem('selectedLocalId')

                            setTimeout(() => {
                                navigate(`/${routes.storeProfileMain}`)
                            })
                        }}
                        className="pointer"
                        style={{
                            justifyContent: 'center',
                            display: 'flex',
                            marginTop: 20,
                        }}
                    >
                        <Text
                            label="Volver a vista de comercio"
                            fontSize={14}
                            fontWeight={900}
                            color={'#2699D6'}
                            variant={'underline'}
                        />
                    </div>
                )}
                {!isLocalView() && (
                    <div
                        className="pointer"
                        onClick={closeModal}
                        style={{ marginTop: 16 }}
                    >
                        <Text
                            label="Cerrar ventana"
                            fontSize={14}
                            fontWeight={900}
                            color={'#2699D6'}
                            variant={'underline'}
                            textAlign="center"
                        />
                    </div>
                )}
            </ModalComponent>
        )
    }
    console.log('commerce', commerce)
    return (
        <LayoutComponent
            header={{
                onChat: () => handlerNavigate('communication'),
            }}
            drawer={{
                commerce: {
                    path: isLocalViewApplied ? commerce?.logo : AmipassLogo,
                    name: isLocalViewApplied
                        ? commerce?.nameLocal
                        : establishment?.name,
                    address: isLocalViewApplied
                        ? getLocalAddress()
                        : establishment?.address,
                    code: isLocalViewApplied
                        ? user?.sEstablecimiento + getLocal().slice(1, 3)
                        : establishment?.id,
                    plan: commerce?.plan ?? '',
                },
                onHome: () => {
                    if (!isLocalViewApplied) {
                        handlerNavigate(
                            routes.storeProfileMain,
                            clevertapEvents.drawerHomeAdmin
                        )
                        return
                    }
                    handlerNavigate(
                        routes.localMain,
                        clevertapEvents.drawerHome
                    )
                },
                onPay: () => {
                    track(
                        clevertapEvents.amiposweb_cobrafacil_pagoqr,
                        drawerEventParms
                    )
                    handlerNavigate(`/${routes.payment}`)
                },
                onChangeLocal: () => {
                    if (isUserAdmin) {
                        if (!isSingleStore) {
                            setShowStoreModal(true)
                            return
                        }

                        if (selectedLocal) {
                            setSelectedLocal(undefined)
                            localStorage.removeItem('selectedLocal')
                            localStorage.removeItem('selectedLocalId')

                            setTimeout(() => {
                                navigate(`/${routes.storeProfileMain}`)
                            })
                            return
                        }
                        const store = storeList[0]

                        setSelectedLocal(store.shopId.toString())
                        setSelectedLocalId(store.localId.toString())

                        localStorage.setItem(
                            'selectedLocal',
                            store.shopId.toString()
                        )
                        localStorage.setItem(
                            'selectedLocalId',
                            store.localId.toString()
                        )

                        // Llamamos a la función asíncrona y navegamos
                        const fetchCategoriesAndNavigate = async () => {
                            await getCategoriesByCommerce()
                            navigate(`/${routes.localMain}`)
                        }

                        fetchCategoriesAndNavigate()
                    }
                },
                onProfile: () => {
                    handlerNavigate(`/${routes.storeProfileMain}`)
                },

                menu: [
                    {
                        sectionName: 'Impulsa tus ventas',
                        highlight: features.marketplace ? undefined : true,
                        preText: features.marketplace ? undefined : (
                            <div>
                                <SvgIcon width={20} iconName="IconSales" />
                            </div>
                        ),
                        onNavigate: features.marketplace
                            ? undefined
                            : () => handlerNavigate(`/${routes.impulsa}`),
                        onClickEvent: () => {
                            track(
                                clevertapEvents.amiposweb_impulsatusventas,
                                drawerEventParms
                            )
                        },
                        hide: !isLocalViewApplied,
                        menu: [
                            {
                                title: 'Tu tienda en App',
                                icon: 'IconCart',
                                rightIcon: (
                                    <img
                                        src={require('../../assets/icons/drawer-amipass.png')}
                                        alt="logo"
                                        style={{
                                            marginLeft: 5,
                                            width: 20,
                                            height: 20,
                                        }}
                                    />
                                ),
                                menu: [
                                    {
                                        title: 'Mis pedidos',
                                        icon: 'IconoMtorcycle',
                                        onClick: () => {
                                            track(
                                                clevertapEvents.amiposweb_impulsatusventas_marketplace_mis_pedidos,
                                                drawerEventParms
                                            )
                                            upselling.upselling.marketplace
                                                ? handlerNavigate(
                                                      routes.orders,
                                                      clevertapEvents.homeLandingOrders
                                                  )
                                                : handlerNavigate(
                                                      '/marketplace?s=m'
                                                  )
                                        },
                                    },
                                ],
                            },
                            {
                                title: 'Promociones',
                                icon: 'IconPercentage',
                                onClick() {
                                    track(
                                        clevertapEvents.amiposweb_atraemasclientes_promociones,
                                        drawerEventParms
                                    )

                                    if (upselling.upselling.drawer.promotions) {
                                        handlerNavigate(
                                            `/${routes.promotionMain}`
                                        )
                                    } else {
                                        navigate('/promotions')
                                        window.open(
                                            'https://amipass.typeform.com/to/BcTVDWHf?typeform-source=amipass.atlassian.net',
                                            '_blank'
                                        )
                                    }
                                },
                                // onClick() {
                                //     handlerNavigate(routes.promotionMain)
                                // },
                            },

                            {
                                title: 'Liquida productos próximos a vencer',
                                icon: 'IconPercentageBag',
                                hide: !isLocalViewApplied,
                                onClick: () => {
                                    track(
                                        clevertapEvents.amiposweb_atraemasclientes_liquidarproductosproximosvencer,
                                        drawerEventParms
                                    )
                                    upselling.upselling.marketplace
                                        ? handlerNavigate(
                                              `/${routes.products}/${routes.liquidate}`,
                                              clevertapEvents.drawerLiquidate
                                          )
                                        : navigate('settlement')
                                    // handlerNavigate(
                                    //     `/${routes.products}/${routes.liquidate}`,
                                    //     clevertapEvents.drawerLiquidate
                                    // )
                                },
                            },
                            {
                                title: 'Tu E-commerce',
                                icon: 'IconPercentageBag',
                                hide: true,
                                /*  onClick: () => {
                                    ;() => {}
                                }, */
                            },
                            /*  {
                                title: 'Marketplace amiPASS',
                                icon: 'IconCart',

                                menu: [
                                    {
                                        title: 'Mis productos',
                                        icon: 'IconList',
                                        onClick: () => {
                                            track(
                                                clevertapEvents.amiposweb_impulsatusventas_marketplace_misproductos,
                                                drawerEventParms
                                            )
                                            upselling.upselling.marketplace
                                                ? handlerNavigate(
                                                      routes.inventory,
                                                      clevertapEvents.homeLandingInventory
                                                  )
                                                : handlerNavigate(
                                                      '/marketplace?s=h'
                                                  )
                                        },
                                    },
                                ],
                            }, */
                        ],
                    },
                    {
                        sectionName: 'Mis productos',
                        onClickEvent: () => {
                            track(
                                clevertapEvents.amiposweb_atraemasclientes,
                                drawerEventParms
                            )
                        },
                        hide: !isLocalViewApplied,
                        menu: [
                            {
                                title: 'Lista de productos',
                                hide:
                                    !features.amimarket || !isLocalViewApplied,
                                icon: (
                                    <img
                                        src={drawerProductListIcon}
                                        height={20}
                                        width={20}
                                    />
                                ),
                                onClick: () => {
                                    track(
                                        clevertapEvents.amiposweb_impulsatusventas_marketplace_misproductos,
                                        drawerEventParms
                                    )
                                    upselling.upselling.marketplace
                                        ? handlerNavigate(
                                              routes.inventory,
                                              clevertapEvents.homeLandingInventory
                                          )
                                        : handlerNavigate('/marketplace?s=h')
                                },
                            },

                            {
                                title: 'Cargar productos',
                                hide: !isAdmin(),
                                icon: (
                                    <img
                                        src={drawerBellIcon}
                                        height={20}
                                        width={20}
                                    />
                                ),
                                onClick: () => {
                                    track(
                                        clevertapEvents.amiposweb_impulsatusventas_marketplace_cargarproductos,
                                        drawerEventParms
                                    )
                                    upselling.upselling.marketplace
                                        ? handlerNavigate(
                                              routes.products,
                                              clevertapEvents.homeLandingProducts
                                          )
                                        : handlerNavigate('/marketplace?s=p')
                                },
                            },
                            {
                                title: 'Analítica de productos',
                                hide: true, //!isAdmin(),
                                icon: (
                                    <img
                                        src={drawerAnalitycsIcon}
                                        height={20}
                                        width={20}
                                    />
                                ),
                            },
                        ],
                    },
                    /* {
                        sectionName: 'Atrae más clientes',
                        onClickEvent: () => {
                            track(
                                clevertapEvents.amiposweb_atraemasclientes,
                                drawerEventParms
                            )
                        },
                        hide: !isLocalViewApplied,
                        menu: [
                            {
                                title: 'Sello - EcoFriendly',
                                icon: 'IconEco',
                                onClick: () => {
                                    if (commerce?.eco) {
                                        track(
                                            clevertapEvents.amiposweb_atraemasclientes_selloecofriendly,
                                            drawerEventParms
                                        )
                                        navigate(`/${routes.ecofriendCommerce}`)
                                    } else {
                                        navigate(`/${routes.ecofriendSurvey}`)
                                    }
                                },
                            },
                        ],
                    }, */
                    {
                        sectionName: 'Administra tu negocio',
                        onClickEvent: () => {
                            track(
                                clevertapEvents.amiposweb_administratunegocio,
                                drawerEventParms
                            )
                        },
                        menu: [
                            {
                                title: 'Resumen de Ventas',
                                icon: 'IconSummary',
                                hide: !isLocalViewApplied,
                                onClick: () => {
                                    handlerNavigate(`/${routes.sales}`)

                                    track(
                                        clevertapEvents.amiposweb_administratunegocio_resumendeventas,
                                        drawerEventParms
                                    )
                                },
                            },
                            {
                                title: 'Anticipa tus pagos',
                                icon: 'IconInvoice',
                                hide: isLocalViewApplied,
                                onClick: () => {
                                    handlerNavigate(
                                        'facturacion/payment/' +
                                            routes.payProforma
                                    )
                                },
                            },
                            {
                                title: 'Facturación y Pago',
                                icon: 'IconDollar',
                                onClick: () => {
                                    track(
                                        clevertapEvents.amiposweb_administratunegocio_facturacionypagos,
                                        drawerEventParms
                                    )
                                    handlerNavigate(`/${routes.billing}`)
                                },
                            },
                            {
                                title: 'Análisis de tu negocio',
                                icon: 'IconFraction',
                                hide: !isLocalViewApplied,
                                onClick: () => {
                                    if (upselling.upselling.reports) {
                                        handlerNavigate(
                                            routes.urlDashboard,
                                            clevertapEvents.drawerReport
                                        )
                                    } else {
                                        handlerNavigate('analysis')
                                        window.open(
                                            'https://amipass.typeform.com/to/BcTVDWHf?typeform-source=amipass.atlassian.net',
                                            '_blank'
                                        )
                                    }
                                },
                            },
                            {
                                title: '',
                                hide:
                                    isLocalViewApplied ||
                                    !features?.sales_report,
                                icon: (
                                    <img
                                        src={reporte}
                                        height={39}
                                        width={200}
                                    />
                                ),

                                onClick: () => {
                                    handlerNavigate(routes.report)
                                },
                            },
                        ],
                    },
                    {
                        sectionName: 'Mi Cuenta',
                        onClickEvent: () => {
                            track(
                                clevertapEvents.amiposweb_mi_cuenta,
                                drawerEventParms
                            )
                        },
                        menu: [
                            /*  {
                                title: 'Mi local',
                                icon: 'PIconMyBusiness',
                                onClick: () => {
                                    handlerNavigate('communication')
                                },
                            },
                            {
                                title: 'Mi plan',
                                icon: 'PIconMyPlan',
                                onClick: () => {
                                    handlerNavigate(routes.myPlan)
                                },
                            },
                            {
                                title: 'Complementos',
                                icon: 'PIconAddons',
                                onClick: () => {
                                    handlerNavigate('communication')
                                },
                            },
                            {
                                title: 'Canal de Comunicacióin',
                                icon: 'IconCaht',
                                onClick: () => {
                                    handlerNavigate('communication')

                                    track(
                                        clevertapEvents.amiposweb_mi_cuenta_canaldecomunicacion_chatayuda,
                                        drawerEventParms
                                    )
                                    track(
                                        clevertapEvents.amiposweb_mi_cuenta_canaldecomunicacion,
                                        drawerEventParms
                                    )
                                },
                            }, */

                            {
                                title: 'Mis Datos',
                                icon: 'IconData',
                                onClick: () => {
                                    handlerNavigate(
                                        `/${routes.storeConfigurations}`
                                    )
                                    track(
                                        clevertapEvents.amiposweb_mi_cuenta_canaldecomunicacion_configuracion,
                                        drawerEventParms
                                    )
                                    track(
                                        clevertapEvents.amiposweb_mi_cuenta_canaldecomunicacion_configuracion_misdatos,
                                        drawerEventParms
                                    )
                                },
                            },
                            {
                                title: 'Mis Locales',
                                icon: 'IconData',
                                hide: isLocalViewApplied,
                                onClick: () => {
                                    if (
                                        isSingleStore &&
                                        storeList.length === 1
                                    ) {
                                        const store = storeList[0] // Tomamos el único comercio disponible

                                        setSelectedLocal(
                                            store.shopId.toString()
                                        )
                                        setSelectedLocalId(
                                            store.localId.toString()
                                        )

                                        localStorage.setItem(
                                            'selectedLocal',
                                            store.shopId.toString()
                                        )
                                        localStorage.setItem(
                                            'selectedLocalId',
                                            store.localId.toString()
                                        )

                                        const fetchCategoriesAndNavigate =
                                            async () => {
                                                await getCategoriesByCommerce()
                                                handlerNavigate(
                                                    `/${routes.localMain}`
                                                )
                                            }

                                        fetchCategoriesAndNavigate()
                                    } else {
                                        handlerNavigate(`/${routes.storeMain}`)
                                    }
                                },
                            },
                            {
                                hide: isLocalViewApplied,
                                title: 'Cambio de clave',
                                icon: <img src={key} height={20} width={20} />,
                                onClick: () => {
                                    handlerNavigate(`/${routes.changePass}`)
                                },
                            },
                            {
                                title: 'Mi plan',
                                hide: !isLocalView(),
                                icon: (
                                    <img
                                        src={subscriptionIcon}
                                        height={20}
                                        width={20}
                                    />
                                ),
                                onClick: () =>
                                    handlerNavigate(`/${routes.subscription}`),
                            },
                            {
                                hide: !isLocalViewApplied,
                                title: 'Sello - EcoFriendly',
                                icon: 'IconEco',
                                onClick: () => {
                                    if (commerce?.eco) {
                                        track(
                                            clevertapEvents.amiposweb_atraemasclientes_selloecofriendly,
                                            drawerEventParms
                                        )
                                        navigate(`/${routes.ecofriendCommerce}`)
                                    } else {
                                        navigate(`/${routes.ecofriendSurvey}`)
                                    }
                                },
                            },
                            {
                                title: 'Cerrar sesión',
                                icon: 'IconLogout',
                                onClick: handlerLogout,
                            },
                        ],
                    },
                ],
            }}
        >
            {children}
            {renderChangeStore()}
        </LayoutComponent>
    )
}
